const miusuario = false

function reducer( state = miusuario, { type, payload } ){
    switch( type ){
        case 'guardarUsuario': {
            return payload
        }
        case 'cerrarSesion': {
            return false
        }
        default:
            return state
    }
}

export default reducer